<template>
    <div class="md user-audio">
        <a href="http://www.fpc.com.tw/fpcw/index.php?op=proD" target="_blank" :title="$t('site.func.file')"></a>
    </div>
</template>

<script>

    export default {
        data: function(){

            return {
                result: {},
            }
        },
    }
</script>

<style scoped lang="scss">

    .md.user-audio {
        @extend %header-btn-caption;

        > a {

            &::before {
                content: '\e873';
            }
        }

        @include media('mobile') {
            display: none;
        }
    }
</style>
